import {TFillableFieldDialogState} from "./types";

export const initialState: TFillableFieldDialogState = {
    text: '',
    insertEverywhere: false,
}